import { Form, Input, Modal, ModalProps } from 'antd'
import React, { useEffect } from 'react'
import { FormItem } from '../../components/form-item'
import { useTranslation } from 'react-i18next'
import { useStoreCandidate } from '../hooks'
import { Campaign } from '../../campaign/campaign'
import useForm from '../../hooks/use-form'
import { StoreInput } from '../input/store-input'
import { Candidate } from '../candidate'

type CampaignCreateModalProps = {
    campaignId: Campaign['id']
    missedCandidateId?: string
    initialValues?: Partial<StoreInput>
    onSuccess?: (candidate: Candidate) => void
} & ModalProps

export function CandidateCreateModal({
    campaignId,
    missedCandidateId,
    initialValues,
    onSuccess,
    ...rest
}: CampaignCreateModalProps) {
    const { t } = useTranslation()

    const mutation = useStoreCandidate(campaignId, missedCandidateId)

    const formProps = useForm({
        mutation,
        onSuccess: (candidate) => {
            formProps.form.resetFields()
            onSuccess?.(candidate)

            if (!rest?.onCancel) {
                return
            }

            rest?.onCancel({} as never)
        },
    })

    useEffect(() => {
        if (!rest.open) {
            return
        }

        formProps.form.setFieldsValue(initialValues ?? {})
    }, [formProps.form, initialValues, rest.open])

    return (
        <Modal
            {...rest}
            title={t('Add candidate')}
            onOk={() => formProps.form.submit()}
            okText={t('Add candidate')}
            okButtonProps={{
                loading: mutation.isPending,
            }}
        >
            <Form
                layout="vertical"
                {...formProps}
            >
                <FormItem
                    label={t('First name')}
                    name="firstName"
                    required
                >
                    <Input />
                </FormItem>
                <FormItem
                    label={t('Last name')}
                    name="lastName"
                    required
                >
                    <Input />
                </FormItem>
                <FormItem
                    label={t('Phone')}
                    name="phone"
                    required
                >
                    <Input />
                </FormItem>
                <FormItem
                    label={t('Email')}
                    name="email"
                >
                    <Input />
                </FormItem>
            </Form>
        </Modal>
    )
}
